import { render, staticRenderFns } from "./viewInvoiceDetails.vue?vue&type=template&id=144184b5&scoped=true"
import script from "./viewInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./viewInvoiceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144184b5",
  null
  
)

export default component.exports